// extracted by mini-css-extract-plugin
export default {"popup":"UtmDv","container":"gcf1T","iconClose":"bRRbD","wrapperImage":"Z0KeR","img":"dqQDu","iconPlay":"Sboek","content":"huLW4","title":"azHtF","text":"Wc7rE"};